import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";

import CreateIcon from "@material-ui/icons/Create";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "Stores/Management/types";
import { Values } from "Tools/Values";
import ApplicationForm from "@src/Components/Pages/Main/Content/Applications/ApplicationForm/ApplicationForm";
import { ApplicationLink } from "@src/Interfaces/Entity/ApplicationLink";
import { IFile } from "@src/Interfaces/Entity/File";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  application: ApplicationLink;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
export default class ApplicationEdit extends React.Component<IProps> {
  @observable editOpened: boolean = false;

  handleOpenEdit = () => {
    this.editOpened = true;
  };
  handleCloseEdit = () => {
    this.editOpened = false;
  };

  handleUpdate = async (values: ApplicationLink) => {
    if (values.fileImage.name === "reset") {
      values.image = this.props.values.common.EmptyId;
      values.imageUrl = "";
    } else if (values.fileImage.name !== "default") {
      const file: IFile = await this.props.management.uploadFile(
        values.fileImage,
        values.id,
        this.props.values.fileTypes.ApplicationImage
      );
      values.image = file.id;
      values.imageUrl = file.url;
    }

    await this.props.management.saveApplicationLink(values);
    this.editOpened = false;
  };

  render() {
    const application: ApplicationLink = {
      ...this.props.application,
      fileImage: new File([], "default")
    };
    return (
      <React.Fragment>
        <RoundButton
            icon={<CreateIcon/>}
            tooltipTitle={Values.getLocalizationValue("edit")}
            onClick={() => this.handleOpenEdit()}
        />
        
        <SimpleModal
          width={500}
          isOpened={this.editOpened}
          onClose={this.handleCloseEdit}
        >
          <ApplicationForm
            title={Values.getLocalizationValue("edit")}
            initialValues={application}
            onSubmit={this.handleUpdate}
            onClose={this.handleCloseEdit}
          />
        </SimpleModal>
      </React.Fragment>
    );
  }
}
